export async function inIframe(
    action,
    initialHtml,
    domPollInterval = 50
  ) {
    const d = document
  
    // document.body can be null while the page is loading
    while (!d.body) {
      await wait(domPollInterval)
    }
  
    const iframe = d.createElement('iframe')
  
    try {
      await new Promise((_resolve, _reject) => {
        let isComplete = false
        const resolve = () => {
          isComplete = true
          _resolve()
        }
        const reject = (error) => {
          isComplete = true
          _reject(error)
        }
  
        iframe.onload = resolve
        iframe.onerror = reject
        const { style } = iframe
        style.setProperty('display', 'block', 'important') // Required for browsers to calculate the layout
        style.position = 'absolute'
        style.top = '0'
        style.left = '0'
        style.visibility = 'hidden'
        if (initialHtml && 'srcdoc' in iframe) {
          iframe.srcdoc = initialHtml
        } else {
          iframe.src = 'about:blank'
        }
        d.body.appendChild(iframe)
  
        // WebKit in WeChat doesn't fire the iframe's `onload` for some reason.
        // This code checks for the loading state manually.
        // See https://github.com/fingerprintjs/fingerprintjs/issues/645
        const checkReadyState = () => {
          // The ready state may never become 'complete' in Firefox despite the 'load' event being fired.
          // So an infinite setTimeout loop can happen without this check.
          // See https://github.com/fingerprintjs/fingerprintjs/pull/716#issuecomment-986898796
          if (isComplete) {
            return
          }
  
          // Make sure iframe.contentWindow and iframe.contentWindow.document are both loaded
          // The contentWindow.document can miss in JSDOM (https://github.com/jsdom/jsdom).
          if (iframe.contentWindow?.document?.readyState === 'complete') {
            resolve()
          } else {
            setTimeout(checkReadyState, 10)
          }
        }
        checkReadyState()
      })
  
      while (!iframe.contentWindow?.document?.body) {
        await wait(domPollInterval)
      }
  
      return await action(iframe, iframe.contentWindow)
    } finally {
      iframe.parentNode?.removeChild(iframe)
    }
  }